module.exports = __webpack_public_path__ + "assets/img/404.cb2515ac.svg";